module.exports = ({ NPM_RN_CLIENT }) => `// npm
npm i ${NPM_RN_CLIENT} --save

// yarn
yarn add ${NPM_RN_CLIENT}
`;
